<div class="wrapper">
  <table>
    <tr>
      @for (col of columns; track col) {
        <th (click)="sortColumn(col)" class="column-header" [ngClass]="{sortable: isColumnSorted(col)}">{{ 'fhm.' + type +'.columns.' + col | translate}}
          @if (sortedColumn === col) {
            <div class="sortable-icon" [ngClass]="{ascending: this.sortedColumnAscend}"></div>
          }</th>
        }
        @if (showDelete || showDownloadLog || showDownloadReport || showAction) {
          <th>{{'fhm.common.label.actions' | translate}}</th>
        }
      </tr>
      @for (record of records; track record) {
        @if (!record.hidden) {
          <tr>
            @for (key of columns; track key; let i = $index) {
              @if (i === 0 && showLink) {
                <td>
                  <div class="grouped">
                    <div class="status-indicator ">
                      <span class="dot" [ngClass]="{'status-OK': record['status'] === 'OK', 'status-FAIL': record['status'] === 'FAIL', 'status-UNKNOWN': record['status'] === 'UNKNOWN'}"></span>
                    </div>
                    <fui-link-button [title]="record[key]" (click)="selectRecord.emit(record)"></fui-link-button>
                  </div>
                </td>
              }
              @if (!styleColumnFn || styleColumnFn(key, record) !== 'link') {
                @if (i !== 0 || !showLink) {
                  <td><p [ngStyle]="styleColumnFn ? styleColumnFn(key, record) : undefined" [ngClass]="{'status-online': record[key] === 'Online', 'status-offline': record[key] === 'Offline', 'status-noPlan': record[key] === 'No Plan'}">{{ valueColumnFn ? valueColumnFn(key, record) : record[key] }}</p></td>
                }
              }
              @if (styleColumnFn && styleColumnFn(key, record) === 'link') {
                <td>
                  <fui-link-button [title]="valueColumnFn ? valueColumnFn(key, record) : record[key]" (click)="linkColumnClicked.emit(record)"></fui-link-button>
                </td>
              }
            }
            @if (showDelete || showDeleteFunc || showRecontinueFunc) {
              <td>
                @if (showDelete || (showDeleteFunc && showDeleteFunc(record))) {
                  <fui-action [attr.title]="'fhm.common.label.delete' | translate" (click)="deleteRecord.emit(record)">
                    <fui-icon [height]="20" [icon]="'delete'" [width]="20"></fui-icon>
                  </fui-action>
                }
                @if (showRecontinueFunc && showRecontinueFunc(record)) {
                  <fui-action [attr.title]="'fhm.common.label.recontinue' | translate" (click)="recontinueRecord.emit(record)">
                    <fui-icon [height]="20" [icon]="'restart'" [width]="20"></fui-icon>
                  </fui-action>
                }
              </td>
            }
            @if (showDownloadLog) {
              <td>
                <fui-action [attr.title]="'fhm.common.label.downloadLog' | translate" (click)="downloadLog.emit(record)">
                  <fui-icon [height]="20" [icon]="'circle-arrow-down'" [width]="20"></fui-icon>
                </fui-action>
              </td>
            }
            @if (showDownloadReport) {
              <td>
                <fui-action [attr.title]="'fhm.common.label.downloadReport' | translate" (click)="downloadReport.emit(record)">
                  <fui-icon [height]="20" [icon]="'circle-arrow-down'" [width]="20"></fui-icon>
                </fui-action>
              </td>
            }
            @if (showAction) {
              <td>
                <fui-action [attr.title]="actionLabel | translate" (click)="actionClicked.emit(record)">
                  <fui-icon [height]="20" [icon]="'settings'" [width]="20"></fui-icon>
                </fui-action>
              </td>
            }
          </tr>
        }
      }
    </table>

  </div>

